import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Leaf, Lock, Mail, Smartphone } from 'lucide-react';
import { trackInitiateCheckout } from '../utils/metaPixel';
const includes = ['📋 Plan de alimentación de 7 días', '🥗 Recetas y combinaciones anti-inflamatorias', '⏰ Rutina diaria paso a paso', '💧 Guía de hidratación y hábitos saludables'];
export function HeroSection() {
  return <section className="bg-wellness-white pt-28 pb-16 px-6 min-h-[85vh] flex items-center" id="hero" data-id="element-96">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-97">
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6
      }} className="flex flex-col items-start" data-id="element-98">
          {/* Product type label */}
          <span className="text-sm text-wellness-green font-medium mb-4" data-id="element-99">
            Guía digital · PDF descargable
          </span>

          {/* Headline */}
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-wellness-dark leading-tight mb-4" data-id="element-100">
            Sentirte liviana y cómoda en 7 días
          </h1>

          {/* Subheadline */}
          <p className="text-lg md:text-xl text-wellness-dark/80 mb-4 max-w-lg" data-id="element-101">
            Una guía paso a paso con hábitos simples para reducir la hinchazón —
            sin dietas extremas ni restricciones.
          </p>

          {/* Author line */}
          <div className="flex items-center gap-2 text-sm text-wellness-dark/60 mb-6" data-id="element-102">
            <Leaf className="w-4 h-4 text-wellness-green" data-id="element-103" />
            <span data-id="element-104">Creada por el equipo de Cuerpo en Calma</span>
          </div>

          {/* Divider */}
          <div className="w-full h-px bg-wellness-sage/30 mb-6" data-id="element-105" />

          {/* What's included */}
          <div className="mb-6" data-id="element-106">
            <span className="text-xs font-bold uppercase tracking-wide text-wellness-dark/70 mb-3 block" data-id="element-107">
              Qué incluye:
            </span>
            <ul className="space-y-2" data-id="element-108">
              {includes.map((item, index) => <li key={index} className="flex items-center gap-2 text-wellness-dark" data-id="element-109">
                  <CheckCircle2 className="w-4 h-4 text-wellness-green flex-shrink-0" data-id="element-110" />
                  <span data-id="element-111">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* CTA */}
          <a href="https://cuerpoencalma.it.com/cart/49295445262573:1" target="_blank" rel="noopener noreferrer" onClick={() => trackInitiateCheckout('hero_cta')} className="inline-block bg-wellness-gold text-white px-8 py-4 rounded-full font-bold text-lg tracking-wide shadow-xl shadow-wellness-gold/30 hover:bg-yellow-600 transition-all hover:scale-105 active:scale-95 mb-4" data-id="element-112">
            Quiero mi guía — US$ 6.36
          </a>

          {/* Trust line */}
          <div className="flex flex-wrap items-center gap-4 text-sm text-wellness-dark/60" data-id="element-113">
            <span className="flex items-center gap-1" data-id="element-114">
              <Lock className="w-4 h-4" data-id="element-115" /> Pago seguro
            </span>
            <span className="flex items-center gap-1" data-id="element-116">
              <Mail className="w-4 h-4" data-id="element-117" /> Entrega inmediata
            </span>
            <span className="flex items-center gap-1" data-id="element-118">
              <Smartphone className="w-4 h-4" data-id="element-119" /> PDF descargable
            </span>
          </div>
        </motion.div>

        {/* Ebook image */}
        <motion.div initial={{
        opacity: 0,
        x: 30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative w-full max-w-md mx-auto lg:max-w-full" data-id="element-120">
          <div className="relative aspect-[4/5] rounded-3xl overflow-hidden shadow-2xl shadow-wellness-dark/10 border-8 border-white bg-white" data-id="element-121">
            <img src="https://cdn.magicpatterns.com/uploads/txuGu6zxp7ct7eeTeKiNm6/LOLOYEI.png" alt="Reset de Hinchazón en 7 Días - Guía PDF" className="w-full h-full object-cover object-center" data-id="element-122" />
          </div>
        </motion.div>
      </div>
    </section>;
}